<script setup lang="ts">
import {Component} from "vue";

interface IPanel {
  label: string;
  icon?: Component;
  number: number;
  type?: "error" | "default";
  size?: "small" | "large";
  isActive: boolean;
}

const props = withDefaults(defineProps<IPanel>(), {
  label: "",
  items: [],
  type: "default",
  size: "small",
  isActive: false,
});
</script>

<template>
  <div class="c-cu-panel" :class="[size, type, { active: isActive }]">
    <div class="panel__header">
      <div v-if="icon" class="panel__header--icon">
        <component :is="icon" :size="20"/>
      </div>
      <div class="panel__header--label">
        {{ label }}
      </div>
    </div>
    <div class="panel__body">
      {{ number }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-cu-panel {
  border: 1px solid var(--color-border);
  width: 100%;
  border-radius: 16px;
  padding: 12px;
  box-shadow: var(--box-shadow);
  height: 104px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    border-color: var(--color-label);
  }

  .panel__header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    &--label {
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      font-weight: 600;
      color: var(--color-label);
      display: flex;
      align-items: center;
    }

    &--icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: var(--color-bg-secondary);
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--color-label);

      svg {
        background: transparent;
      }
    }
  }

  .panel__body {
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0;
    font-weight: 700;
    color: var(--color-label);
  }

  &.large {
    .panel__header {
      margin-bottom: 8px;
    }
  }

  &.error {
    &:hover {
      border-color: var(--color-red);
    }

    .panel__header {
      &--icon {
        color: var(--color-red) !important;
      }
    }

    .panel__body {
      color: var(--color-red);
    }
  }

  &.active {
    border: 2px solid var(--color-secondary-label);
    padding: 11px;

    &.error {
      border-color: var(--color-red);
    }
  }
}
</style>
